import { DEFAULT_STATE } from '../constants'

export const initialLicensesState = {
  licenses: DEFAULT_STATE.licenses,
  aiUsageAllowed: DEFAULT_STATE.aiUsageAllowed,
}
